/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const deleteReport = /* GraphQL */ `
  mutation DeleteReport(
    $input: DeleteReportInput!
    $condition: ModelReportConditionInput
  ) {
    deleteReport(input: $input, condition: $condition) {
      id
      reportType
      year
      slug
      inputFile
      validatedFile
      dataImportMethod
      hrisProvider
      currentStep
      headQuarterFullAddress
      oneschemaSessionToken
      oneschemaData
      oneschemaSessionTokenExpiredTime
      priceCents
      owner
      resultGenerated
      snapshotStartDate
      snapshotEndDate
      hrisDataSyncing
      hrisDataResynced
      createdAt
      updatedAt
    }
  }
`;
export const createPayment = /* GraphQL */ `
  mutation CreatePayment(
    $input: CreatePaymentInput!
    $condition: ModelPaymentConditionInput
  ) {
    createPayment(input: $input, condition: $condition) {
      id
      reportId
      stripePaymentId
      amount
      data
      createdAt
      updatedAt
    }
  }
`;
export const updatePayment = /* GraphQL */ `
  mutation UpdatePayment(
    $input: UpdatePaymentInput!
    $condition: ModelPaymentConditionInput
  ) {
    updatePayment(input: $input, condition: $condition) {
      id
      reportId
      stripePaymentId
      amount
      data
      createdAt
      updatedAt
    }
  }
`;
export const deletePayment = /* GraphQL */ `
  mutation DeletePayment(
    $input: DeletePaymentInput!
    $condition: ModelPaymentConditionInput
  ) {
    deletePayment(input: $input, condition: $condition) {
      id
      reportId
      stripePaymentId
      amount
      data
      createdAt
      updatedAt
    }
  }
`;
export const createReport = /* GraphQL */ `
  mutation CreateReport(
    $input: CreateReportInput!
    $condition: ModelReportConditionInput
  ) {
    createReport(input: $input, condition: $condition) {
      id
      reportType
      year
      slug
      inputFile
      validatedFile
      dataImportMethod
      hrisProvider
      currentStep
      headQuarterFullAddress
      oneschemaSessionToken
      oneschemaData
      oneschemaSessionTokenExpiredTime
      priceCents
      owner
      resultGenerated
      snapshotStartDate
      snapshotEndDate
      hrisDataSyncing
      hrisDataResynced
      createdAt
      updatedAt
    }
  }
`;
export const updateReport = /* GraphQL */ `
  mutation UpdateReport(
    $input: UpdateReportInput!
    $condition: ModelReportConditionInput
  ) {
    updateReport(input: $input, condition: $condition) {
      id
      reportType
      year
      slug
      inputFile
      validatedFile
      dataImportMethod
      hrisProvider
      currentStep
      headQuarterFullAddress
      oneschemaSessionToken
      oneschemaData
      oneschemaSessionTokenExpiredTime
      priceCents
      owner
      resultGenerated
      snapshotStartDate
      snapshotEndDate
      hrisDataSyncing
      hrisDataResynced
      createdAt
      updatedAt
    }
  }
`;
export const createJobCategoryMapping = /* GraphQL */ `
  mutation CreateJobCategoryMapping(
    $input: CreateJobCategoryMappingInput!
    $condition: ModelJobCategoryMappingConditionInput
  ) {
    createJobCategoryMapping(input: $input, condition: $condition) {
      id
      mappingJSON
      owner
      createdAt
      updatedAt
    }
  }
`;
export const updateJobCategoryMapping = /* GraphQL */ `
  mutation UpdateJobCategoryMapping(
    $input: UpdateJobCategoryMappingInput!
    $condition: ModelJobCategoryMappingConditionInput
  ) {
    updateJobCategoryMapping(input: $input, condition: $condition) {
      id
      mappingJSON
      owner
      createdAt
      updatedAt
    }
  }
`;
export const deleteJobCategoryMapping = /* GraphQL */ `
  mutation DeleteJobCategoryMapping(
    $input: DeleteJobCategoryMappingInput!
    $condition: ModelJobCategoryMappingConditionInput
  ) {
    deleteJobCategoryMapping(input: $input, condition: $condition) {
      id
      mappingJSON
      owner
      createdAt
      updatedAt
    }
  }
`;
export const createEstablishment = /* GraphQL */ `
  mutation CreateEstablishment(
    $input: CreateEstablishmentInput!
    $condition: ModelEstablishmentConditionInput
  ) {
    createEstablishment(input: $input, condition: $condition) {
      id
      fullAddress
      establishmentName
      workAddressLine1
      workAddressLine2
      city
      state
      zipCode
      naicsCode
      majorActivity
      hasCPDRReportLastYear
      hasEEO1ReportLastYear
      owner
      createdAt
      updatedAt
    }
  }
`;
export const updateEstablishment = /* GraphQL */ `
  mutation UpdateEstablishment(
    $input: UpdateEstablishmentInput!
    $condition: ModelEstablishmentConditionInput
  ) {
    updateEstablishment(input: $input, condition: $condition) {
      id
      fullAddress
      establishmentName
      workAddressLine1
      workAddressLine2
      city
      state
      zipCode
      naicsCode
      majorActivity
      hasCPDRReportLastYear
      hasEEO1ReportLastYear
      owner
      createdAt
      updatedAt
    }
  }
`;
export const deleteEstablishment = /* GraphQL */ `
  mutation DeleteEstablishment(
    $input: DeleteEstablishmentInput!
    $condition: ModelEstablishmentConditionInput
  ) {
    deleteEstablishment(input: $input, condition: $condition) {
      id
      fullAddress
      establishmentName
      workAddressLine1
      workAddressLine2
      city
      state
      zipCode
      naicsCode
      majorActivity
      hasCPDRReportLastYear
      hasEEO1ReportLastYear
      owner
      createdAt
      updatedAt
    }
  }
`;
